import React from 'react';

class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false, error: null };
  }

  static getDerivedStateFromError(error) {
    return { hasError: true, error };
  }

  componentDidCatch(error, errorInfo) {
    console.error('ErrorBoundary caught:', error, errorInfo);
  }

  handleReload = () => {
    window.location.reload();
  };

  render() {
    if (this.state.hasError) {
      return (
        <div className="min-h-screen flex items-center justify-center bg-gray-50 px-4">
          <div className="text-center max-w-md">
            <div className="text-6xl mb-4">:(</div>
            <h1 className="text-2xl font-bold text-gray-800 mb-2">Something went wrong</h1>
            <p className="text-gray-600 mb-4">
              An unexpected error occurred. Please try reloading the page.
            </p>
            <details className="text-left mb-4 bg-red-50 rounded-lg p-3 border border-red-200">
              <summary className="text-sm font-medium text-red-700 cursor-pointer">Error details (click to expand)</summary>
              <pre className="text-xs text-red-600 mt-2 whitespace-pre-wrap break-all">
                {this.state.error?.message || 'Unknown error'}
                {'\n\n'}
                {this.state.error?.stack?.split('\n').slice(0, 8).join('\n')}
              </pre>
            </details>
            <button
              onClick={this.handleReload}
              className="px-6 py-3 bg-blue-600 text-white rounded-lg hover:bg-blue-700 font-medium transition-colors"
            >
              Reload Page
            </button>
          </div>
        </div>
      );
    }

    return this.props.children;
  }
}

export default ErrorBoundary;
